// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loading-layout[data-v-4fd06b9c]{background-color:rgba(0,0,0,.3);min-height:100vh;position:absolute;display:flex;align-items:center;justify-content:center;width:100%;z-index:1005!important}", ""]);
// Exports
module.exports = exports;
